<template>
	<div class="stock-box-main">
		<div class="stock-box-summary mt-50">
			<div class="summary-box">
				<div
					class="summary-item"
					:class="[stockQuoteData.change && stockQuoteData.change > 0 ? '' : 'summary-item--down']"
				>
					<span>{{ $t('enterprise.chg') }}</span>
					<span>{{ formatConvertByPrice(stockQuoteData.change) }}</span>
					<RiseFallRange
						size="8"
						:type="stockQuoteData.change && stockQuoteData.change > 0 ? 'up' : 'down'"
						class="ml-4"
					/>
				</div>
				<div
					class="summary-item"
					:class="[stockQuoteData.changePct && stockQuoteData.changePct > 0 ? '' : 'summary-item--down']"
				>
					<span>{{ $t('enterprise.%Chg') }}</span>
					<span>{{ formatConvertByPrice(stockQuoteData.changePct) }}%</span>
				</div>
			</div>
			<div class="summary-box">
				<div class="summary-item">
					<span>{{ $t('enterprise.high') }}</span>
					<span>{{ formatConvertByPrice(stockQuoteData.highPrice) }}</span>
				</div>
				<div class="summary-item">
					<span>{{ $t('enterprise.low') }}</span>
					<span>{{ formatConvertByPrice(stockQuoteData.lowPrice) }}</span>
				</div>
			</div>
		</div>
		<!-- 最新一期股东总户数，单独一行 -->
		<div class="summary-extra mt-21">
			<span class="summary-extra-label">最新一期股东总户数</span>
			<span class="summary-extra-value">{{ latestTotalAccount }}</span>
		</div>
		<div class="stock-box-footer mt-72">{{ formatDateFn(stockQuoteData.tradingDay) }}</div>
	</div>
</template>

<script setup>
import { defineProps, getCurrentInstance } from 'vue';
import RiseFallRange from '@/components/RiseFallRange.vue';
import { useStockVO } from '@/rebuild/hooks/useStockVO';

const props = defineProps({
	stockQuoteData: {
		type: Object,
		default: () => ({})
	},
	latestTotalAccount: {
		type: String,
		default: '--'
	}
});

const { proxy } = getCurrentInstance();
const { formatConvertByPrice } = useStockVO();

const formatDateFn = date => {
	if (!date) return;
	return `${proxy.$t('enterprise.common-a.until')} ${date}`;
};
</script>

<style lang="less" scoped>
.stock-box-main {
	width: 392px;
}

.stock-box-summary {
	display: flex;

	.summary-box {
		& + .summary-box {
			margin-left: 48px;
		}
	}
	.summary-item {
		display: flex;
		align-items: baseline;

		& + .summary-item {
			margin-top: 21px;
		}

		span {
			&:nth-child(1) {
				color: #4e5969;
				font-size: 16px;
				font-weight: 400;
				line-height: 140%;
			}
			&:nth-child(2) {
				margin-left: 4px;
				color: #333;
				font-family: Barlow;
				font-size: 24px;
				font-weight: 500;
				line-height: normal;
			}
		}
	}
}

.summary-extra {
	display: flex;
	align-items: baseline;
	gap: 4px;

	&-label {
		color: #4e5969;
		font-size: 16px;
		font-weight: 400;
		line-height: 140%;
	}

	&-value {
		margin-left: 4px;
		color: #333;
		font-family: Barlow;
		font-size: 24px;
		font-weight: 500;
		line-height: normal;
	}
}

.stock-box-footer {
	width: 100%;
	color: #86909c;
	font-size: 12px;
	font-weight: 400;
	line-height: 16px;
}

.stock-wrapper--half .stock-box-main {
	width: 300px;

	.stock-box-summary .summary-box {
		& + .summary-box {
			margin-left: 25px !important;
		}
	}
}
</style>
